const svgIcon = (path) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:5px">${path}</svg>`;

const ICON_PERSON = svgIcon(`<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>`);
const ICON_PHONE  = svgIcon(`<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.39 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16z"/>`);
const ICON_WRENCH = svgIcon(`<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>`);
const ICON_COPY   = svgIcon(`<rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>`);

export const buildTallerInfoContent = (taller, fnKey) =>
  `<div style="font-family:sans-serif;font-size:13px;line-height:1.8;min-width:220px">
    <div>${taller.calle} ${taller.numeroExterior}, ${taller.colonia}</div>
    <div>${taller.alcaldiaMunicipio}, ${taller.estado} — CP ${taller.cp}</div>
    <hr style="margin:6px 0;border:none;border-top:1px solid #eee">
    <div>${ICON_PERSON}${taller.contacto !== 'nan' ? taller.contacto : '—'}</div>
    <div>${ICON_PHONE}${taller.telefono}</div>
    <div style="color:#555">${ICON_WRENCH}${taller.marcaTaller}</div>
    <hr style="margin:6px 0;border:none;border-top:1px solid #eee">
    <button onclick="window['${fnKey}'](this)" style="width:100%;padding:4px 0;font-size:12px;cursor:pointer;border:1px solid #d9d9d9;border-radius:4px;background:#fafafa;display:flex;align-items:center;justify-content:center;gap:4px">${ICON_COPY}Copiar datos</button>
  </div>`;

export const buildTallerTexto = (taller) => {
  const contacto = taller.contacto !== 'nan' ? taller.contacto : '—';
  return `${taller.nombreComercial}\n${taller.calle} ${taller.numeroExterior}, ${taller.colonia}\n${taller.alcaldiaMunicipio}, ${taller.estado} — CP ${taller.cp}\nContacto: ${contacto}\nTel: ${taller.telefono}\nMarcas: ${taller.marcaTaller}`;
};

export const crearTallerMarker = ({ map, taller, infoWindowRef, setLatLng }) => {
  const lat = parseFloat(taller.latitud);
  const lng = parseFloat(taller.longitud);
  if (isNaN(lat) || isNaN(lng)) return null;

  const marker = new window.google.maps.Marker({
    map,
    position: { lat, lng },
    title: taller.nombreComercial,
    icon: { url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png' },
  });

  const fnKey = `__copyTaller_${taller.latitud}_${taller.longitud}`.replace(/\./g, '_');
  const texto = buildTallerTexto(taller);

  window[fnKey] = (btn) => {
    navigator.clipboard.writeText(texto);
    btn.textContent = '✓ Copiado';
    setTimeout(() => { btn.innerHTML = `${ICON_COPY}Copiar datos`; }, 2000);
  };

  marker.addListener('click', () => {
    setLatLng({ lat, lng });
    infoWindowRef.current.setHeaderContent(taller.nombreComercial);
    infoWindowRef.current.setContent(buildTallerInfoContent(taller, fnKey));
    infoWindowRef.current.open(map, marker);
  });

  return marker;
};

export const limpiarTalleres = (markersRef, talleres) => {
  markersRef.current.forEach(m => m.setMap(null));
  markersRef.current = [];
  talleres?.forEach(t => {
    delete window[`__copyTaller_${t.latitud}_${t.longitud}`.replace(/\./g, '_')];
  });
};
